import React, { useState } from 'react';
import { RichTextDisplay } from '@marageti/z4-lib';
import {
  Box, Card, CardContent, CardHeader, Typography, useMediaQuery, useTheme,
} from '@mui/material';

interface AboutContentProps {
  aboutUs: string;
  isExpanded: boolean;
  onToggle: () => void;
}

const MobileContent = ({ aboutUs, isExpanded, onToggle }: AboutContentProps) => {
  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      onToggle();
    }
  };

  return (
    <Box sx={{ position: 'relative' }}>
      {/* Clamped text */}
      <Box
        sx={{
          display: '-webkit-box',
          WebkitBoxOrient: 'vertical',
          WebkitLineClamp: isExpanded ? 'unset' : 3,
          overflow: 'hidden',
          whiteSpace: 'normal',
          wordBreak: 'break-word',
        }}
      >
        <RichTextDisplay
          sx={{
            display: '-webkit-box',
            WebkitBoxOrient: 'vertical',
            WebkitLineClamp: isExpanded ? 'unset' : 5,
            overflow: 'hidden',
            // mimic "spacing" by adding a margin to child elements
            '& p + p': {
              marginTop: '20px',
            },
          }}
        >
          {aboutUs}
        </RichTextDisplay>
      </Box>

      {/* Read More / Less button */}
      <Typography
        onClick={onToggle}
        onKeyDown={handleKeyDown}
        sx={{
          color: 'primary.main',
          cursor: 'pointer',
          justifyContent: 'center',
          display: 'flex',
        }}
        variant="captionBold"
        role="button"
        tabIndex={0}
      >
        {isExpanded ? 'Read Less' : 'Read More'}
      </Typography>
    </Box>
  );
};

interface AboutCardProps {
  aboutUs: string;
  onSidebar?: boolean;
}

const AboutCard = ({ aboutUs, onSidebar = false }: AboutCardProps) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const handleToggleExpand = () => {
    setIsExpanded((prev) => !prev);
  };

  return (
    <Card data-e2e="ztest-trip-match-about" sx={{ mb: 2 }}>
      <CardHeader title="About Us" />
      <CardContent>
        {isMobile || onSidebar ? (
          <MobileContent
            aboutUs={aboutUs}
            isExpanded={isExpanded}
            onToggle={handleToggleExpand}
          />
        ) : (
          <RichTextDisplay>
            {aboutUs}
          </RichTextDisplay>
        )}
      </CardContent>
    </Card>
  );
};

export default AboutCard;
